import classNames from "classnames"

// to ensure all messages use the same base classes
const messageBaseClasses =
    "tw-px-3 tw-py-2 tw-whitespace-pre-line theme-bubble animate-fade--in animate--fast"

interface Props {
    shouldAddNoteTheme: boolean
    shouldAddCloudBackground: boolean
}

const getMessageBaseClasses = ({
    shouldAddNoteTheme,
    shouldAddCloudBackground,
}: Props): string => {
    return classNames(messageBaseClasses, {
        "theme-note": shouldAddNoteTheme,
        "bg-cloud": shouldAddCloudBackground,
    })
}

export default getMessageBaseClasses
